import { createBaseApiClient } from './baseApiClient';

function resolveManagementApiBaseUrl(config) {
  return String(config?.managementApiBaseUrl || '').replace(/\/$/, '');
}

export function createManagementApiService(config) {
  const managementApiBaseUrl = resolveManagementApiBaseUrl(config);
  const client = createBaseApiClient(config, managementApiBaseUrl);

  async function getApplicationFiles({ clientId, applicationNumber, caseId }) {
    const query = new URLSearchParams();

    if (clientId) {
      query.set('clientId', clientId);
    }

    if (applicationNumber) {
      query.set('applicationNumber', applicationNumber);
    }

    if (caseId) {
      query.set('caseId', caseId);
    }

    const queryString = query.toString();
    const path = queryString
      ? `/api/mfu/v1/media/application/files?${queryString}`
      : '/api/mfu/v1/media/application/files';

    return client.get(path);
  }

  async function getApplicationFileStatusSummary({ clientId, applicationNumber, caseId }) {
    const query = new URLSearchParams();

    if (clientId) {
      query.set('clientId', clientId);
    }

    if (applicationNumber) {
      query.set('applicationNumber', applicationNumber);
    }

    if (caseId) {
      query.set('caseId', caseId);
    }

    return client.get(`/api/mfu/v1/media/application/files/status?${query.toString()}`);
  }

  async function getInternalCaseFiles(caseId) {
    return client.get(`/api/mfu/v1/internal/media/${encodeURIComponent(caseId)}/files`);
  }

  async function createMediaRecord(payload) {
    return client.post('/api/mfu/v1/media', payload);
  }

  async function createTranscriptRecord(payload) {
    return client.post('/api/mfu/v1/transcript', payload);
  }

  async function deleteMedia(caseId, mediaId, payload) {
    return client.delete(`/api/mfu/v1/media/${encodeURIComponent(caseId)}/${encodeURIComponent(mediaId)}`, payload);
  }

  async function deleteTranscript(caseId, mediaId, payload) {
    return client.delete(`/api/mfu/v1/transcript/${encodeURIComponent(caseId)}/${encodeURIComponent(mediaId)}`, payload);
  }

  async function updateScanStatusByFile(payload) {
    return client.post('/api/mfu/v1/media/scan-status/by-file', payload);
  }

  async function getPlaybackUrl({ caseId, mediaId, isInternalZoneRequest = false }) {
    const query = new URLSearchParams({
      caseId,
      mediaId,
      isInternalZoneRequest: isInternalZoneRequest ? 'true' : 'false'
    });

    return client.get(`/api/mfu/v1/media/playback-url?${query.toString()}`);
  }

  return {
    getApplicationFiles,
    getApplicationFileStatusSummary,
    getInternalCaseFiles,
    createMediaRecord,
    createTranscriptRecord,
    deleteMedia,
    deleteTranscript,
    updateScanStatusByFile,
    getPlaybackUrl,
    request: client.request,
    get: client.get,
    post: client.post,
    delete: client.delete,
    baseUrl: client.baseUrl,
    defaultHeaders: client.defaultHeaders
  };
}
